// Product Shipping Message Handler
(function () {
  // Wait for jQuery and DOM to be ready
  if (typeof jQuery === "undefined") {
    console.error("jQuery is required for product-shipping.js");
    return;
  }

  jQuery(document).ready(function ($) {
    // Check if the required variables are set
    if (
      typeof window.productShippingConfig === "undefined" ||
      !window.productShippingConfig.ca_amount ||
      !window.productShippingConfig.prod_amount
    ) {
      console.log("Product shipping configuration not found");
      return;
    }

    var ca_amount = window.productShippingConfig.ca_amount;
    var usa_amount = window.productShippingConfig.usa_amount;
    var prod_amount = window.productShippingConfig.prod_amount;

    jQuery.get(
      "https://ipinfo.io",
      function (response) {
        console.log(response, ca_amount, prod_amount);
        var count = 0;
        if (response.country == "CA") {
          console.log(prod_amount, ca_amount);
          if (ca_amount > prod_amount) {
            count++;
            var text = $(".inside_ca_prod_less").text();
            $(".product-single-shipping a span:not(.icon)").html("");
            $(".product-single-shipping a span:not(.icon)").html(
              text + '<br> <span class="text-link">Learn More</span>'
            );
          } else {
            count++;
            var text = $(".inside_ca_prod_over").text();
            $(".product-single-shipping a span:not(.icon)").html("");
            $(".product-single-shipping a span:not(.icon)").html(
              text + '<br> <span class="text-link">Learn More</span>'
            );
            console.log(text, "above");
          }
        } else if (response.country == "US" || response.country == "USA") {
          if (usa_amount > prod_amount) {
            count++;
            var text = $(".inside_usa_prod_less").text();
            $(".product-single-shipping a span:not(.icon)").html("");
            $(".product-single-shipping a span:not(.icon)").html(
              text + '<br> <span class="text-link">Learn More</span>'
            );
          } else {
            count++;
            var text = $(".inside_usa_prod_over").text();
            $(".product-single-shipping a span:not(.icon)").html("");
            $(".product-single-shipping a span:not(.icon)").html(
              text + '<br> <span class="text-link">Learn More</span>'
            );
          }
        } else {
          count++;
          console.log("global", $(".global_msg").text());
          var text = $(".global_msg").text();
          $(".product-single-shipping a span:not(.icon)").html("");
          $(".product-single-shipping a span:not(.icon)").html(
            text + '<br> <span class="text-link">Learn More</span>'
          );
        }
      },
      "jsonp"
    );
  });
})();
